<template>
  <BaseViewComponent
    name="features-grid"
    :is-preview="isPreview"
  >
    <div class="features-grid-wrapper full-width flex justify-between items-center">
      <div class="container">
        <div class="flex justify-between">
          <div class="left">
            <div class="title-h2">
              {{ pageData.featuresGridTitle }}
            </div>
            <div class="text-p">
              {{ pageData.featuresGridDescription }}
            </div>
          </div>
          <div class="right relative-position">
            <div class="laptop-image">
              <div
                v-if="featuresGridImageLaptop"
                class="relative-position"
              >
                <img
                  class="frame relative-position"
                  src="/landing/laptop-frame.png"
                  width="100%"
                >
                <img
                  class="absolute border-radius-10"
                  :src="getCompressImage(featuresGridImageLaptop)"
                  width="100%"
                >
              </div>
              <img
                v-else
                src="/landing/laptop-cover.png"
                width="100%"
              >
            </div>
            <div class="phone-image absolute">
              <div
                v-if="featuresGridImagePhone"
                class="relative-position uploaded"
              >
                <img
                  class="frame relative-position"
                  src="/landing/phone-frame.png"
                  width="100%"
                >
                <img
                  class="absolute border-radius-10"
                  :src="image"
                  width="100%"
                >
              </div>
              <img
                v-else
                src="/landing/phone-cover.png"
                width="100%"
              >
            </div>
          </div>
        </div>
        <div class="flex items">
          <div
            v-for="(item, index) in pageData.featuresGridItems"
            :key="index"
            class="item flex no-wrap border-radius-16"
          >
            <div class="icon-wrapper flex items-center justify-center">
              <q-icon
                :name="item.icon"
                class="icon"
                color="white"
              />
            </div>
            <div>
              <div class="title-h4 q-mb-sm">{{ item.title }}</div>
              <div class="note-p">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import useBookPageEdit from 'src/composables/useBookPageEdit';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import getCompressImage from 'src/helpers/getCompressImage';
import { computed } from 'vue';

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const {
  featuresGridImageLaptop,
  featuresGridImagePhone,
} = useBookPageEdit();

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);

const image = computed(() => getCompressImage(featuresGridImagePhone.value));
</script>

<style lang="scss" scoped>
</style>
